import type { SVGProps } from "react";
import { cn } from "../";

const LoaderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    viewBox={"0 0 24 24"}
    className={cn("lucide h-4 w-4", !!props.className && props.className)}
    {...props}
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
);
export default LoaderIcon;
